// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__18z5C","title":"AfterFrontImage_title__1yCrT"};